import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from "moment";
import { applicationStatuses, statusTypes } from "../config/constants";
import { Panel, Button } from "react-bootstrap";
import { getStatusForApplication } from "../libs/utilities";
import { updateApplicationStatus } from "../actions";

class ApplicationStatus extends Component {
  constructor(props) {
    super(props);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleDecline = this.handleDecline.bind(this);
  }

  handleAccept() {
    const { dispatch } = this.props;
    dispatch(updateApplicationStatus(applicationStatuses.ADMITTED.code));
  }

  handleDecline() {
    const { dispatch } = this.props;
    dispatch(updateApplicationStatus(applicationStatuses.DECLINED.code));
  }

  render() {
    const { application, periods } = this.props;
    const applicationPeriod = periods.find(period => period.periodId === application.periodId);
    const applicationStatus = getStatusForApplication(application, applicationPeriod);
    const disqualified = applicationStatus ? applicationStatus.code === 'DQ' : false;
    const accepted = applicationStatus ? applicationStatus.code === 'AC' : false;
    const documentsSubmitted = disqualified && application.evaluations ?
      !!application.evaluations.documentation
      :
      false;
    const explanation = disqualified && application.evaluations ?
      application.evaluations.comments ?
        application.evaluations.comments.applications ?
          application.evaluations.comments.applications
          : ''
        :
        ''
      :
      '';
    return(
      <Panel header='Application Status' bsStyle={statusTypes.INFO}>
        <dl className="dl-horizontal">
          { application.submittedAt &&
            <Fragment>
              <dt>Submitted</dt>
              <dd>{moment(application.submittedAt).format('MM/DD/YY h:mma')}</dd>
            </Fragment>
          }
          <dt>Status</dt>
          <dd>{applicationStatus.text}</dd>
          <dt>Description</dt>
          <dd>{applicationStatus.description.map((descPart, index) => (<p key={index}>{descPart}</p>))}</dd>
          { applicationStatus.files && applicationStatus.files.filter(file => file.programId === application.programId).map((file, index) => (
            <Fragment key={index}>
              <dt>File(s)</dt>
              <dd>
                <a href={file.path}>{file.title}</a>
              </dd>
            </Fragment>
          ))
          }
          { disqualified &&
            <Fragment>
              <dt>Explanation</dt>
              <dd>{ explanation }</dd>
              { !documentsSubmitted &&
                <dd>Documentation not submitted</dd>
              }
            </Fragment>
          }
        </dl>
        { application.upgradeOption &&
          <Panel bsStyle="info">Advanced Placement Requested</Panel>
        }
        { accepted &&
        <Panel header='Program Acceptance' bsStyle="primary">
          <p>To finalize your acceptance into the program, please indicate your decision regarding the space that is
          being provided to you.</p>
          <Button bsStyle='primary' onClick={this.handleAccept}>Accept</Button>
          <Button bsStyle='danger' className='pull-right' onClick={this.handleDecline}>Decline</Button>
        </Panel>
        }
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  const { application, applicationPeriods } = state.appInfo;
  return {
    application,
    periods: applicationPeriods
  }
}

export default connect(mapStateToProps)(ApplicationStatus);